import { gql } from "apollo-boost"

export const GET_ACTIVITY_ASSISTANTS_AND_ASSISTANCE_AND_COUNT = gql`
  query getActivityAssistantsAndAssistance($activityId: ID!, $skip: Float, $first: Float, $filter: String) {
    activityAssistantsCount (activityId: $activityId, filter: $filter)
    activityAssistantsAndAssistance (activityId: $activityId, skip: $skip, first: $first, filter: $filter) {
      id
      folio
      name
      lastName
      maidenName
      gender
      birthdate
      beneficiary
      assistance {
        id
        hasAssist
        assistanceAt
        activitySchedule {
          id
          startTime
          scheduledAt
        }
        activity {
          id
          description
          title
        }
      }
    }
  }
`
